// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroVariant2_wrapper__6PRGT","tile":"HeroVariant2_tile__uzSxn"};